export default "__VITE_ASSET__18244175__"